import { ReactElement } from 'react';
import { Message, useMessage } from '@messageformat/react';
import { space } from '@op/opds.tokens';
import { Row } from '@op/opds.opux';
import parseMsgContent from '../../util/parseMsgContent';
import PathToInvestor from './PathToInvestor';
import TextComponent from '../TextComponent';
import { ReactComponent as Image009 } from '../../images/OP_symbolikuvitus_128_009.svg';
import { ReactComponent as Image075 } from '../../images/OP_symbolikuvitus_96_075.svg';
import { ReactComponent as Image008 } from '../../images/OP_symbolikuvitus_128_008.svg';
import { ReactComponent as Image072 } from '../../images/OP_symbolikuvitus_96_072.svg';
import InvestmentComparisonGraph from './InvestmentComparisonGraph';
import InflationGraph from './InflationGraph';
import TaskOne from './TaskOne';
import TaskTwo from './TaskTwo';
import CourseHeader from '../CourseHeader';
import CourseComplete from '../CourseComplete';
import CourseContent from '../CourseContent';

const Course1 = (): ReactElement => {
  const firstIntro = useMessage('course1.courseContent.part1');
  const secondIntro = useMessage('course1.courseContent.part2');
  const investColumns = useMessage('course1.you_can_invest');
  const parsedFirstIntro = parseMsgContent(firstIntro);
  const parsedSecondIntro = parseMsgContent(secondIntro);
  const parsedInvest = parseMsgContent(investColumns);

  return (
    <div style={{ marginBottom: space.default }}>
      <CourseHeader
        courseTitleId="course1.title"
        courseHeaderText="how_to_start"
        Image={Image009}
        courseNumber={1}
      />
      <CourseContent content={parsedFirstIntro} />
      <InflationGraph />
      <CourseContent content={parsedSecondIntro} />
      <InvestmentComparisonGraph />
      <Image075
        className="investoracademy-small-svg"
        style={{
          marginTop: space.xl,
        }}
        aria-hidden="true"
      />
      <h2
        className="opds-styles-v1-text-title-xxl"
        style={{ textAlign: 'center', paddingBottom: space.default }}
      >
        <Message id="course1.path_to_investor.title" />
      </h2>
      <div
        className="opds-styles-v1-text-body-medium"
        style={{ textAlign: 'center', paddingBottom: space.default }}
      >
        <Message id="course1.path_to_investor.body" />
      </div>
      <PathToInvestor />
      <div
        style={{
          textAlign: 'center',
          marginTop: space.xl,
        }}
      >
        <Image008
          className="investoracademy-small-svg"
          style={{ paddingBottom: space.default }}
          aria-hidden="true"
        />
        <h2 className="investoracademy-title-hero">
          <Message id="course1.every_investor.title" />
        </h2>
      </div>
      <TextComponent messageId="course1.every_investor.body" twoColumns />
      <Row style={{ margin: 0 }}>
        <CourseContent content={parsedInvest} />
      </Row>
      <Image072
        className="investoracademy-small-svg"
        style={{
          marginTop: space.xxl,
        }}
        aria-hidden="true"
      />
      <h2 className="investoracademy-title-xxl align-center">
        <Message id="course1.risks.title" />
      </h2>
      <p className="investoracademy-text-paragraph align-center">
        <Message id="course1.risks.body" />
      </p>
      <TaskOne />
      <TaskTwo />
      <CourseComplete messageId="course1.recap" />
    </div>
  );
};

export default Course1;
